import { BlueLink } from 'components/common/link';
import { TranslationContext } from 'contexts/translation-context';
import { useContext } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0 0 45px 0;
`;
const Title = styled.div`
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
  margin-top: 40px;
  font-family: ${props => props.theme.fonts.montserratMedium};
  color: ${props => props.theme.colors.black};
`;
const ContentMessage = styled.div`
  font-size: 12px;
  text-align: center;
  font-family: ${props => props.theme.fonts.montserratLight};
  white-space: break-space;
  padding-bottom: 12px;
  color: ${props => props.theme.colors.black};
`;
const ConfirmAndCheckoutNotSuccessModal = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  return (
    <Container>
      <Title>{TRANSLATION_TEXT.error}!</Title>
      <ContentMessage>
        {TRANSLATION_TEXT.request_failed_please}
        <BlueLink to={'https://www.rapnet.com/contact/support/'} newTab>
          {TRANSLATION_TEXT.contact_us_lower}
        </BlueLink>
        {TRANSLATION_TEXT.for_assistance}
      </ContentMessage>
    </Container>
  );
};

export default ConfirmAndCheckoutNotSuccessModal;
